import polygonClipping from 'polygon-clipping'

export function polygonsIntersect(a: [number, number][], b: [number, number][]) {
  const result = polygonClipping.intersection([[a]], [[b]])

  return result.length > 0
}
